import styled from "styled-components";

export const DashboardWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: stretch;
    width: 100%;
    height: 100%;
`;

export const DashboardHeader = styled.div`
    display: grid;
    width: 100%;
    height: 150px;
    margin-top: 40px;
    grid-template-columns: 1fr 1fr 1fr;
    grid-gap: 20px;
    align-items: stretch;
    justify-items: stretch;
    box-sizing: border-box;
`;

export const StatisticsItem = styled.div`
    display: flex;
    flex-direction: column;
    align-items: stretch;
    border: 1px solid #F0F0F0;
    border-radius: 5px;
    background-size: cover;
    color: #EFEFEF;
    position: relative;
    overflow: hidden;
`;

export const StatisticsItemContent = styled.div`
    background-color: rgba(0, 0, 0, 0.7);
    width: 100%;
    height: 100%;
    padding: 10px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    align-items: stretch;
    justify-content: space-between;
`;


export const StatisticsTitle = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    font-size: 14px;
    letter-spacing: 2px;
    padding: 5px 0px;
    color: #CCCCCC;
`;

export const StatisticsContent = styled.div`
    display: flex;
    flex-direction: row;
    align-items: stretch;
    justify-content: space-between;
    font-family: Helvetica, Arial, sans-serif;

    & .ant-progress-inner {
        background-color: rgba(255, 255, 255, 0.5);
    }
`;

export const Statistics = styled.div`
    display: flex;
    flex-direction: column;
    align-items: stretch;
    width: 100%;
`;

export const StatisticsIcon = styled.div`
    color: rgba(255, 255, 255, 0.1);
    padding: 0px 10px;
    position: absolute;
    top: 0px;
    right: 0px;
`;

export const StatisticsText = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
`;

export const StatisticsValue = styled.div`
    font-size: 36px;
    color: #EFEFEF;
    padding: 5px 0px;
`;

export const StatisticsDesc = styled.div`
    display: inline-block;
    font-size: 12px;
    text-align: center;
    border-radius: 5px;
    background-color: rgba(255, 255, 255, 0.15);
    padding: 3px 5px;
    overflow: hidden;
    margin: 20px 5px 0px 5px;
`;

export const DashboardBody = styled.div`
    display: grid;
    width: 100%;
    height: 600px;
    grid-template-columns: 1fr 1fr 1fr;
    grid-template-rows: 1fr 1fr;
    grid-gap: 20px;
    align-items: stretch;
    justify-items: stretch;
    box-sizing: border-box;
    margin-top: 20px;
`;

export const TenantDeviceMapWrapper = styled.div`
    grid-column: 1 / 3;
    grid-row: 1 / 3;
    border-radius: 5px;
    overflow: hidden;
`;

export const TenantDeviceStatisticsWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: stretch;
    background-color: rgba(0, 0, 0, 0.7);
    border: 1px solid #F0F0F0;
    border-radius: 5px;
    overflow: hidden;
    padding: 10px;
`;

export const TenantDeviceStatisticsItem = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 10px 0px;
    box-sizing: border-box;
    cursor: pointer;

    &:hover {
        background: linear-gradient(0deg, rgba(55, 72, 108, 0.5) 0%, rgba(55, 72, 108, 0.0) 50%, rgba(55, 72, 108, 0.5) 100%);
    }
`;

export const TenantDeviceStatisticsContent = styled.div`
    display: flex;
    flex-direction: column;
    align-items: stretch;
    color: #EFEFEF;
`;

export const TenantDeviceStatisticsTitle = styled.div`
    font-size: 14px;
    display: flex;
    flex-direction: row;
    align-items: center;
    font-size: 14px;
    letter-spacing: 2px;
    padding: 5px 0px;
    color: #CCCCCC;
`;

export const TenantNameAndDeviceCount = styled.div`
    flex: 1 1 auto;
    display: flex;
    flex-direction: column;
    align-items: stretch;

    & .ant-progress {
        font-size: 0px;
        line-height: 1;
    }

    & .ant-progress-outer {
        font-size: 0px;
        line-height: 1;
    }

    & .ant-progress-inner {
        background-color: rgba(255, 255, 255, 0.2);
    }

    & .ant-progress-text {
        height: 0px;
        color: #EFEFEF;
        font-size: 12px;
        font-style: normal;
        overflow: visible;
        display: flex;
        align-items: center;
    }
`;

export const TenantDeviceTenantName = styled.div`
    flex: 0 0 auto;
    white-space: nowrap;
    text-overflow: ellipsis;
    width: 100px;
    font-style: normal;
    padding: 0px 0px 2px 2px; 
`;


export const TenantDeviceCountText = styled.div`
    display: inline-block;
    width: 75px;
    text-align: right;
    margin-bottom: 5px;
`;

export const TenantDatabaseStatisticsWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: stretch;
    background-color: rgba(0, 0, 0, 0.7);
    border: 1px solid #F0F0F0;
    border-radius: 5px;
    overflow: hidden;
    padding: 10px;
`;

export const TenantDatabaseStatisticsTitle = styled.div`
    font-size: 14px;
    display: flex;
    flex-direction: row;
    align-items: center;
    font-size: 14px;
    letter-spacing: 2px;
    padding: 5px 0px;
    color: #CCCCCC;
`;

export const TenantDatabaseStatisticsContent = styled.div`
    display: flex;
    flex-direction: column;
    align-items: stretch;
    color: #EFEFEF;
`;

export const TenantDatabaseStatisticsItem = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 10px 0px;
    box-sizing: border-box;
    cursor: pointer;

    &:hover {
        background: linear-gradient(0deg, rgba(55, 72, 108, 0.5) 0%, rgba(55, 72, 108, 0.0) 50%, rgba(55, 72, 108, 0.5) 100%);
    }
`;

export const TenantNameAndDatabaseSize = styled.div`
    flex: 1 1 auto;
    display: flex;
    flex-direction: column;
    align-items: stretch;

    & .ant-progress {
        font-size: 0px;
        line-height: 1;
    }

    & .ant-progress-outer {
        font-size: 0px;
        line-height: 1;
    }

    & .ant-progress-inner {
        background-color: rgba(255, 255, 255, 0.2);
    }

    & .ant-progress-text {
        height: 0px;
        color: #EFEFEF;
        font-size: 12px;
        font-style: normal;
        overflow: visible;
        display: flex;
        align-items: center;
    }
`;

export const TenantDatabaseTenantName = styled.div`
    flex: 0 0 auto;
    white-space: nowrap;
    text-overflow: ellipsis;
    width: 100px;
    font-style: normal;
    padding: 0px 0px 2px 2px; 
`;

export const TenantDatabaseSizeText = styled.div`
    display: inline-block;
    width: 75px;
    text-align: right;
    margin-bottom: 5px;
`;





